// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".videoWrap{width:100%;height:100%;overflow:hidden}.videoWrap .tcplayer{margin:0 auto}.videoWrap #fxTcplayer{width:100%;height:100%;overflow:hidden}.videoWrap #fxTcplayer .vjs-fullscreen-control{display:none}.videoWrap .poster{position:absolute;top:0;height:100%;background:#fff;z-index:1;transition:all .7s;display:flex;width:100%}.videoWrap .poster>img{width:100%;align-self:center}.videoWrap .realShow{left:0}.videoWrap .realHide{left:-101%}", ""]);
// Exports
module.exports = exports;
